import React from "react";

export function Home() {
    return <div className="slides brand" id="home">
        <div className="logo">&nbsp;</div>
        {/*<span className="blazing">blazing</span><span className="torch">torch</span>*/}
    </div>
}